import {useSyncExternalStore} from 'react';

import {dragStore, selectIsDragging} from '../store/dragStore';

export const useIsDragging = () => useSyncExternalStore(dragStore.subscribe, selectIsDragging);
